import { z } from 'zod';
/**
 * Языки интерфейса. Русский — эталон: тексты берутся из макета, остальные переводятся с него.
 * Язык хранится на пользователе, а не на тенанте: в одной команде у людей может быть разный язык.
 */
export const LOCALES = ['ru', 'en', 'de', 'es'];
export const LocaleSchema = z.enum(LOCALES);
export const DEFAULT_LOCALE = 'ru';
/** Соответствие языка тегу BCP-47 для Intl. */
export const LOCALE_TAGS = {
    ru: 'ru-RU',
    en: 'en-GB',
    de: 'de-DE',
    es: 'es-ES',
};
/**
 * Разбор заголовка Accept-Language до поддерживаемого языка.
 * Неизвестные и некорректные значения дают null — вызывающая сторона подставит запасной.
 */
export function pickLocaleFromAcceptLanguage(header) {
    if (!header)
        return null;
    const candidates = header
        .split(',')
        .map((part) => {
        const [tag = '', ...params] = part.trim().split(';');
        const qParam = params.find((p) => p.trim().startsWith('q='));
        const q = qParam ? Number.parseFloat(qParam.trim().slice(2)) : 1;
        return { tag: tag.trim().toLowerCase(), q: Number.isFinite(q) ? q : 0 };
    })
        .filter((c) => c.tag.length > 0)
        .sort((a, b) => b.q - a.q);
    for (const candidate of candidates) {
        const primary = candidate.tag.split('-')[0];
        const match = LOCALES.find((locale) => locale === primary);
        if (match)
            return match;
    }
    return null;
}
//# sourceMappingURL=locale.js.map